// src/components/LoadingSpinner/LoadingSpinner.jsx
import React from "react";
import "./Loader.scss";

const Loader = ({ text = "جاري التحميل...", showText = true }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      {showText && <p className="loading-text">{text}</p>}
    </div>
  );
};

export default Loader;
